import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'

export const deleteSiteDetails = async (id: number): Promise<boolean> =>
  axios.delete(`/sitedetails/clearsitedetails?siteId=${id}`).then((res) => res?.data?.result)

type Props = {
  id: number
}

export const useDeleteSiteDetails = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteSiteDetails'],
    mutationFn: ({ id }: Props) => deleteSiteDetails(id),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted site details.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete site details, please try again.')
      }
    },
    throwOnError: false
  })
